<template>
    <div class="sidebar-detail">
        <div class="workflow-detail-container">
            <div class="detail-header-container">
                <h4 class="page-title">{{detailInfo.name}}</h4>
                <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times"></i></div>
            </div>

            <p class="detail-title">{{$t('detail.Details')}}</p>
            <div>
                <table class="recording-detail-table" >
                    <tr>
                        <td>{{$t('detail.Id')}}</td>
                        <td>{{(detailInfo.id) || '-'}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('detail.NumberOfTasks')}}</td>
                        <td>{{(detailInfo.numberOfTasks) || '-'}}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title">{{$t('detail.DateTime')}}</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>{{$t('detail.Modified')}}</td>
                        <td>{{$_getDateTimeFormat(detailInfo.lastModificationTime)}} {{$t('detail.by')}} {{(detailInfo.lastModifierUser||{}).userName || '-'}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('detail.Created')}}</td>
                        <td>{{$_getDateTimeFormat(detailInfo.creationTime)}} {{$t('detail.by')}} {{(detailInfo.creatorUser||{}).userName || '-'}}</td>
                    </tr>
                </table>
            </div>

            <div class="button-group-container" v-if="detailInfo">
                <detail-btn :paramId="detailInfo.id" pageName="WorkflowForm" />
                <div class="button-group-edit-delete">
                    <edit-btn v-if="isEditPermission" :paramId="detailInfo.id" pageName="EditWorkflow" class="sidebar-edit-btn" />
                    <delete-btn v-if="isDeletePermission" class="sidebar-delete-btn" @confirmDelete="handleDelete" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DeleteButton from '@/components/Button/DeleteButton'
import DetailButton from '@/components/Button/DetailButton'
import EditButton from '@/components/Button/EditButton'
import { workflowDelete } from '@/api/workflow'
    export default {
        components: {
            'delete-btn': DeleteButton,
            'detail-btn': DetailButton,
            'edit-btn': EditButton,
        },
        props: {
            detailInfo: {
                type: Object | String
            }
        },
        computed: {
            isEditPermission() {
                return this.$_isIncludePermission("Permissions.Darwin.Workflows.Edit")
            },
            isDeletePermission() {
                return this.$_isIncludePermission("Permissions.Darwin.Workflows.Delete")
            }
        },
        methods: {
            closeDetailPage() {
                this.$store.dispatch('info_sidebar/setInfoSidebar');
            },
            async handleDelete() {
                var res = await workflowDelete({ Id: this.detailInfo.id })
                if(res) {
                    this.$_triggerSuccessNotify("Workflow Deleted")
                    this.$store.dispatch('info_sidebar/getAllLatestData', 'WORKFLOW');
                }
            }
        }
    }
</script>

<style lang="css" scoped>
.sidebar-detail p{
    margin: var(--space-8) 0;
}
.sidebar-detail ul li{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
}
.recording-detail-table tr td{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
    padding: var(--space-4) var(--space-8);
    color: var(--charcoal-black)
}
.detail-title {
    font-weight: 700;
    line-height: 30px;
    border-bottom: 1px solid #eeeeee;
    color: var(--main-color-1)
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
    overflow: hidden;
    text-overflow: ellipsis;
}
.empty-text{
    color: var(--charcoal-black);
    padding-left: var(--space-16);
}

</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/WorkflowSidebar.vue